import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type PtAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatPtToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.preTreatment;
}

export function getPtAdminActionSuccessMessage(
    kind: PtAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatPtToastLabel(code);
    const successByKind: Record<PtAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type PtRow = { id: string; code: string };

export const buildPtAdminPagedListActions = (openConfirm: (kind: PtAdminConfirmKind, item: PtRow) => void) =>
    buildRecordLifecyclePagedListActions<PtRow>(openConfirm, { activeMember: "isActive" });
